import { createFileRoute } from "@tanstack/react-router"
import { editFormSubmissionViewStaticData } from "src/views/EditFormSubmissionView/constants"
import { EditFormSubmissionView } from "src/views/EditFormSubmissionView/EditFormSubmissionView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/forms/submissions/$formSubmissionId/edit",
)({
	component: EditFormSubmissionView,
	staticData: editFormSubmissionViewStaticData,
})
